import { WDD }              from './core/wdd.js';
import { injectSVGSprite }  from './modules/injectSVGSprite.js';
import { carousel }         from './modules/carousel.js';
import { opener }           from './modules/opener.js';
import { videos }           from './modules/videos.js';
import { gallery }          from './modules/gallery.js';
import { variants }         from './modules/variants.js';
import { buyButton }        from './modules/buyButton.js';
import { legalOpenner }     from './modules/legalOpenner.js';

// Early DOM manipulation (runs synchronously at bundle load time)
(() => {
    const headline = document.getElementById('h1cc');
    const category = document.querySelector('.category-description');
    if (headline && category) category.insertAdjacentElement('afterend', headline);
})();

// Register module functions
WDD.injectSVGSprite = injectSVGSprite;
WDD.carousel = carousel;
WDD.opener = opener;
WDD.videos = videos;
WDD.gallery = gallery;
WDD.variants = variants;
WDD.buyButton = buyButton;
WDD.legalOpenner = legalOpenner;

WDD.init = function() {
    if (WDD.__initialized) return;
    WDD.__initialized = true;
    WDD.type = "bp"; // type of the page
    WDD.el = document.getElementById(WDD.type);

    // ------------- Building the page -------------
    Object.values(WDD).forEach(func => typeof func === 'function' && func());

    // ------------- Setting up basic data -------------
    WDD.data.mainNavigationUrl = "/api/navigation";
    WDD.data.isApp     = document.body.classList.contains("mobileapp");
    WDD.data.isMobile  = document.body.classList.contains("mobile");
    WDD.data.orderLink = WDD.data.isApp ? "alza://order1?addcode=" : "/order1.htm?addcode=";
    WDD.data.lang      = WDD.utils.getLanguage();
};

// Initializing WDD scripts
if (!WDD.__initialized) {
    if (document.readyState !== "loading") WDD.init();
    else document.addEventListener("DOMContentLoaded", WDD.init);
}
